import React from 'react';
import { Box, Typography } from '@mui/material';
import { headingLetterSpacing } from '../../../utils/headingTypography';

const HIPPO_ASSET_ORIGIN = 'https://www.hippo.co.za';

const resolveItemHtml = (value) => {
  if (typeof value !== 'string') return '';

  let html = value;

  if (html.includes('&lt;') || html.includes('&gt;')) {
    if (typeof document !== 'undefined') {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = html;
      html = textarea.value;
    }
  }

  return html.replace(
    /src=(["'])\/globalassets\//g,
    `src=$1${HIPPO_ASSET_ORIGIN}/globalassets/`
  );
};

const tableStyles = {
  '& table': {
    width: '100% !important',
    borderRadius: '24px',
    overflow: 'hidden',
    borderCollapse: 'separate !important',
    borderSpacing: '0 !important',
  },
  '& table th, & table td': {
    borderWidth: '1px !important',
    borderStyle: 'solid !important',
    borderColor: '#D6DADB !important',
    textAlign: 'center !important',
    verticalAlign: 'middle',
  },
  '& table thead th': {
    borderTop: '1px solid #D6DADB !important',
    borderBottom: '1px solid #D6DADB !important',
  },
  '& table thead th:not(:first-of-type)': {
    borderLeft: '0 !important',
  },
  '& table thead th:not(:last-of-type)': {
    borderRight: '0 !important',
  },
  '& table th:first-of-type': {
    borderTopLeftRadius: '24px',
  },
  '& table th:last-of-type': {
    borderTopRightRadius: '24px',
  },
  '& table tr:last-of-type td:first-of-type': {
    borderBottomLeftRadius: '24px',
  },
  '& table tr:last-of-type td:last-of-type': {
    borderBottomRightRadius: '24px',
  },
};

const SideCardContent = (props) => {
  const { heading, items, isMobile } = props;

  if (isMobile) {
    return (
      <Box
        sx={{
          width: '100%',
          maxWidth: '100vw',
          backgroundColor: '#F3F6F6',
          display: 'flex',
          justifyContent: 'center',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ width: '100%' }}>
          {/* Blue Header Card */}
          <Box
            sx={{
              width: 'calc(100% - 32px)',
              backgroundColor: '#162F3B',
              borderRadius: '34px',
              padding: '40px 32px',
              mx: '16px',
              zIndex: 2,
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                fontSize: '2rem',
                lineHeight: '2.5rem',
                color: '#FFFFFF',
                letterSpacing: headingLetterSpacing('2rem'),
                textAlign: 'center',
              }}
            >
              {heading}
            </Typography>
          </Box>

          {/* Separate White Cards */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              px: '16px',
              position: 'relative',
              zIndex: 1,
            }}
          >
            {(items || []).map((item, index) => (
              <Box
                key={index}
                sx={{
                  backgroundColor: '#FFFFFF',
                  borderRadius: '48px',
                  padding: '24px 24px',
                  boxSizing: 'border-box',
                  boxShadow:
                    '0px 3px 8px 0px #162F3B1F, 0px 1px 2px 0px #A2ACB133',
                }}
              >
                <Box
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html: resolveItemHtml(item.html),
                  }}
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '1rem',
                    lineHeight: '1.5rem',
                    color: '#162F3B',
                    letterSpacing: '-0.02em',
                    whiteSpace: 'pre-line',
                    width: '100%',
                    ...tableStyles,
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    );
  }

  /* ------------------ DESKTOP (unchanged) ------------------ */
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',

        mt: 0,
      }}
    >
      <Box sx={{ position: 'relative', width: '1100px', display: 'flex' }}>
        {/* Sticky Blue Box */}
        <Box
          sx={{
            position: 'sticky',
            top: '120px',
            width: '440px',
            backgroundColor: '#162F3B',
            borderRadius: '64px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            boxSizing: 'border-box',
            padding: '40px',
            zIndex: 2,
            flexShrink: 0,
            mt: 0,
            mb: 0,
            marginRight: '-80px',
            height: 'fit-content',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              lineHeight: 1.2,
              color: '#FFFFFF',
              letterSpacing: headingLetterSpacing('clamp(2rem, 4vw, 3rem)'),
              mb: '32px',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {heading}
          </Typography>
        </Box>

        {/* Scrollable White Container */}
        <Box
          sx={{
            width: '700px',
            // backgroundColor: '#FFFFFF',
            borderRadius: '48px',
            paddingRight: '80px',
            paddingLeft: '104px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          {(items || []).map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                backgroundColor: '#ffffff',
                padding: '80px',
                borderRadius: '48px',
                boxShadow: '0px 12px 24px -4px rgba(22,47,59,0.12)',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Box
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html: resolveItemHtml(item.html),
                  }}
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#000000',
                    ...tableStyles,
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SideCardContent;
